import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsStaffAnswerRequestModal = (props: {
    active: boolean,
    closeHandler: any,
    requestId: string,
    onDone: any,
}) => {
    const [approve,setApprove] = useState(true);
    const [answer,setAnswer] = useState('');
    const answerId = useId();
    const [answerErr,setAnswerErr] = useState(false);
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            setAnswer('');
            setAnswerErr(false);
            setApprove(true);
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const data = {
            answer:answer.trim(),
            approve:approve,
        };
        if(data.answer.length < 2){
            setAnswerErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/requests/answer',
            {
                id:props.requestId,
                answer:data.answer,
                approved:data.approve ? '1' : '0',
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'پاسخ ذخیره شد و به کارمند اطلاع‌رسانی گردید.',
                    'باشه',
                    5000,
                );
                props.onDone();
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>پاسخگویی به درخواست</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>وضعیت نهایی درخواست:</label>
                        <button className={"techaran-radio-box" + (approve ? ' active':'')} onClick={()=>setApprove(true)}>
                            <div><i/></div>
                            <span>تایید شده</span>
                        </button>
                        <button className={"techaran-radio-box" + (!approve ? ' active' : '')}
                                onClick={() => setApprove(false)}>
                            <div><i/></div>
                            <span>رد شده</span>
                        </button>
                        <label htmlFor={answerId}>پاسخ به درخواست کارمند:</label>
                        <textarea id={answerId}
                                  className={"form-control" + (answerErr ? ' is-invalid':'')}
                                  value={answer}
                                  onChange={e=>{
                                      const t = e.currentTarget.value;
                                      setAnswer(t);
                                      setAnswerErr(false);
                                  }}
                                  style={{minHeight:150,maxHeight:250}}
                        />
                        <div className={"invalid-feedback" + (answerErr ? ' d-block':' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <span className="d-block" style={{fontSize:14,margin:'20px 0',color:'#0a53be'}}>همچنین یک پیامک اطلاع رسانی برای این همکار ارسال خواهد شد.</span>
                        <div className="d-flex justify-content-end align-items-center" style={{gap:5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره پاسخ</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};